import { IFavoriteParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export let RecentlyViewedObjectType = {
  View: 'view',
  Workbook: 'workbook',
  Metric: 'metric',
};

export class MarkRecentlyViewedRequest extends Request<IFavoriteParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('markRecentlyViewed', params);
  }
}
